import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface DetailNavbarProps {
  scrolled: boolean;
}

export default function DetailNavbar({ scrolled }: DetailNavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { label: "业务概览", href: "#overview" },
    { label: "核心能力", href: "#features" },
    { label: "客户案例", href: "#cases" },
    { label: "联系我们", href: "#cta" },
  ];

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      setMobileMenuOpen(false);
    }
  };

  const handleCoreBusinessClick = (e: React.MouseEvent) => {
    e.preventDefault();
    history.back();
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-white/80 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src="https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/45145859d95338398b93e9f0fa2b0f33.png"
                alt="龙创未来"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleAnchorClick(e, item.href)}
                className="text-gray-700 hover:text-teal-600 text-sm font-medium transition-colors duration-200 relative group whitespace-nowrap cursor-pointer"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 transition-all duration-200 group-hover:w-full"></span>
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center">
            <Link
              to="/#contact"
              className="px-6 py-2.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-medium rounded-full hover:from-teal-600 hover:to-teal-700 transition-all duration-200 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              立即咨询
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-2xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* 面包屑导航 - 导航栏下方单独一行 */}
      <div className={`border-t border-gray-100 transition-all duration-300 ${scrolled ? "bg-white" : "bg-white/80 backdrop-blur-md"}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-1.5 py-2 text-sm text-gray-500">
            <Link to="/" className="hover:text-teal-600 transition-colors cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400 w-4 h-4 flex items-center justify-center"></i>
            <button onClick={handleCoreBusinessClick} className="hover:text-teal-600 transition-colors cursor-pointer">
              客户案例
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleAnchorClick(e, item.href)}
                className="block text-gray-700 hover:text-teal-600 text-sm font-medium py-2 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
